import React, { useState } from "react";
import user from "../assets/user.svg";
import cam from "../assets/icons/cam.svg";
const Settings = () => {
  const [selectedTab, setSelectedTab] = useState("info");

  const [profileFormData, setProfileFormData] = useState({
    profileImage: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [passFormData, setPassFormData] = useState({
    oldPass: "",
    newPass: "",
    confirmPass: "",
  });

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileFormData({
      ...profileFormData,
      [name]: value,
    });
  };
  const handlePassChange = (e) => {
    const { name, value } = e.target;
    setPassFormData({
      ...passFormData,
      [name]: value,
    });
  };

  const updateProfile = () => {
    console.log(profileFormData);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setProfileFormData({
        ...profileFormData,
        profileImage: reader.result,
      });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const updatePass = () => {
    console.log(passFormData);
  };

  return (
    <>
      <div className="settings-wrapper">
        <h3>Settings</h3>
        <p>Manage your account settings</p>

        <div className="settings-box">
          <aside>
            <button
              className={selectedTab == "info" ? "active" : ""}
              onClick={() => setSelectedTab("info")}
            >
              Personal Information
            </button>{" "}
            <button
              className={selectedTab == "pass" ? "active" : ""}
              onClick={() => setSelectedTab("pass")}
            >
              Change Password
            </button>
          </aside>

          {/* profile */}
          {selectedTab == "info" && (
            <main>
              <h4>Personal Information</h4>
              <p>Customize your personal information</p>
              <div className="profile-wrapper">
                <div className="profile-pic position-relative mb-4">
                  <label>
                    {profileFormData?.profileImage ? (
                      <img src={profileFormData?.profileImage} alt="" />
                    ) : (
                      <img src={user} alt="" />
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      className="d-none"
                      onChange={handleImageUpload}
                    />
                    <img src={cam} alt="" className="cam" />
                  </label>
                </div>

                <input
                  type="text"
                  placeholder="First Name"
                  className="input-box"
                  name="firstName"
                  value={profileFormData.firstName}
                  onChange={handleProfileChange}
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  name="lastName"
                  className="input-box"
                  value={profileFormData.lastName}
                  onChange={handleProfileChange}
                />
                <input
                  type="email"
                  placeholder="E-mail"
                  name="email"
                  className="input-box"
                  value={profileFormData.email}
                  onChange={handleProfileChange}
                />
                <input
                  type="phone"
                  placeholder="Phone No."
                  name="phone"
                  className="input-box"
                  value={profileFormData.phone}
                  onChange={handleProfileChange}
                />

                <button
                  className="btn-primary fw-normal m-auto "
                  onClick={updateProfile}
                >
                  Update Information
                </button>
              </div>
            </main>
          )}

          {/* password */}
          {selectedTab == "pass" && (
            <main>
              <h4>Change Password</h4>
              <p>Change your password</p>
              <div className="profile-wrapper">
                <input
                  type="password"
                  placeholder="Old Password"
                  className="input-box"
                  name="oldPass"
                  value={passFormData.oldPass}
                  onChange={handlePassChange}
                />
                <input
                  type="password"
                  placeholder="New Password"
                  className="input-box"
                  name="newPass"
                  value={passFormData.newPass}
                  onChange={handlePassChange}
                />
                <input
                  type="password"
                  placeholder="Confirm Password"
                  className="input-box"
                  name="confirmPass"
                  value={passFormData.confirmPass}
                  onChange={handlePassChange}
                />

                <button
                  className="btn-primary fw-normal m-auto "
                  onClick={updatePass}
                >
                  Change Password
                </button>
              </div>
            </main>
          )}
        </div>
      </div>
    </>
  );
};

export default Settings;
